const DEFAULT_SITE_URL = "https://example.com"
const DEFAULT_STORE_NAME = "Store"
const DEFAULT_WHATSAPP_URL = "https://wa.me/"
const DEFAULT_STORE_EMAIL = "info@example.com"
const DEFAULT_STORE_PHONE = "+000000000"
const DEFAULT_STORE_ADDRESS = "Dirección no configurada"
const DEFAULT_STORE_INSTAGRAM = "https://instagram.com"

const normalizeOrigin = (value?: string | null): string | null => {
  if (typeof value !== "string") {
    return null
  }

  const trimmed = value.trim()
  if (!trimmed) {
    return null
  }

  const normalized = trimmed.startsWith("http") ? trimmed : `https://${trimmed}`

  try {
    return new URL(normalized).origin
  } catch {
    return null
  }
}

export const getCanonicalSiteUrl = () => {
  const fromEnv =
    normalizeOrigin(process.env.NEXT_PUBLIC_URL) ??
    normalizeOrigin(process.env.NEXT_PUBLIC_SITE_URL) ??
    normalizeOrigin(process.env.BASE_URL) ??
    normalizeOrigin(process.env.NEXT_PUBLIC_VERCEL_URL) ??
    normalizeOrigin(process.env.VERCEL_URL)

  return fromEnv ?? DEFAULT_SITE_URL
}

export const getCanonicalBackendUrl = (): string | undefined => {
  return (
    normalizeOrigin(process.env.NEXT_PUBLIC_BACKEND_URL) ??
    normalizeOrigin(process.env.BACKEND_URL) ??
    normalizeOrigin(process.env.API_BASE_URL) ??
    undefined
  )
}

const normalizeText = (value?: string | null): string | null => {
  if (typeof value !== "string") {
    return null
  }
  const trimmed = value.trim()
  return trimmed.length ? trimmed : null
}

const normalizeUrl = (value?: string | null): string | null => {
  const trimmed = normalizeText(value)
  if (!trimmed) {
    return null
  }

  const withProtocol = trimmed.startsWith("http") ? trimmed : `https://${trimmed}`
  try {
    return new URL(withProtocol).toString()
  } catch {
    return null
  }
}

export const getStoreName = () =>
  normalizeText(process.env.NEXT_PUBLIC_STORE_NAME) ?? DEFAULT_STORE_NAME

export const getStoreWhatsappUrl = () =>
  normalizeUrl(process.env.NEXT_PUBLIC_WHATSAPP) ?? DEFAULT_WHATSAPP_URL

export const getStoreEmail = () =>
  normalizeText(process.env.NEXT_PUBLIC_EMAIL) ?? DEFAULT_STORE_EMAIL

export const getStorePhone = () =>
  normalizeText(process.env.NEXT_PUBLIC_PHONE) ?? DEFAULT_STORE_PHONE

export const getStoreAddress = () =>
  normalizeText(process.env.NEXT_PUBLIC_ADDRESS) ?? DEFAULT_STORE_ADDRESS

export const getStoreInstagramUrl = () =>
  normalizeUrl(process.env.NEXT_PUBLIC_INSTAGRAM) ?? DEFAULT_STORE_INSTAGRAM

export const buildMailtoLink = () => `mailto:${getStoreEmail()}`

export const getMetadataBase = () => {
  return new URL(getCanonicalSiteUrl())
}

export const getBaseURL = () => {
  return getCanonicalSiteUrl()
}
